import React, { useEffect, useState } from 'react';
import { Col, Collapse, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '../../../components/ui/FontAwesomeIcon';
import {
  getMeasureOptions,
  getPeriodOptions,
  getQuestionOptions, getSegmentOptions,
  getSurveysOptions
} from '../../RankingReportCreationContainer/lib/https';
import { IColumn as IRankingReportColumn } from '../../RankingReportCreationContainer/lib/interfaces';

export const renderHierarchyColumn = (record, property) => {
  return (
    <div
      className={(record.isRollup ? 'bg-neutral' : (record.isIndustryAvg ? 'bg-avannis-avg' : '')) + ' ranking-report-cell'}>
      <span>{record[property]}</span>
    </div>
  );
}
export const renderMeasure = (record, column: IRankingReportColumn) => {
  let measure = record[`measure-${column.id}`];
  const format = !isNaN(measure) ? column.format : '';
  let renderedMeasureValue = '';
  if (measure !== null && !isNaN(measure)) {
    measure = Number(measure);
    renderedMeasureValue = measure.toString();
  }
  if (measure !== null && record.isIndustryAvg) {
    renderedMeasureValue = measure.toString();
  }
  let rank = record[`rank-${column.id}`];
  let renderedRankValue = '';
  if (rank !== null && !isNaN(rank)) {
    rank = Number(rank);
    renderedRankValue = rank.toString();
  }
  let n = record[`n-${column.id}`];
  let renderedNValue = '';
  if (n !== null && !isNaN(n)) {
    n = Number(n);
    renderedNValue = n.toString();
  }
  if (renderedMeasureValue.length > 0 || record.isIndustryAvg) {
    return (
      <div
        className={(record.isRollup ? 'bg-neutral' : (record.isIndustryAvg ? 'bg-avannis-avg' : '')) + ' ranking-report-cell'}>
        <Row>
          {column.addRankingColumn &&
            <Col className="col">
              <span>{renderedRankValue}</span>
            </Col>
          }
          <Col className="col">
            <span>{renderedMeasureValue} {format}</span>
          </Col>
          {column.addNumberOfSurveys &&
            <Col className="col">
              <span>{renderedNValue}</span>
            </Col>
          }
        </Row>
      </div>
    )
  } else {
    return (
      <div>
        -
      </div>
    )
  }
}
export const getColumnHeader = (rrc: IRankingReportColumn) => {
  return (
    <RRHeaderComponent
      name={rrc.name}
      addRankingColumn={rrc.addRankingColumn}
      addNumberOfSurveys={rrc.addNumberOfSurveys}
      period={rrc.period}
      survey={rrc.survey}
      question={rrc.question}
      measure={rrc.measure}
      segment={rrc.segment}
    />
  );
};

interface IHeaderComponentProps {
  name: string
  addRankingColumn: boolean
  addNumberOfSurveys: boolean
  //  filters
  period: string | number
  survey: string | number
  question: string | number
  measure: string | number
  segment: string | number
}

const RRHeaderComponent = (props: IHeaderComponentProps) => {
  const { name, addRankingColumn, addNumberOfSurveys, period, survey, question, measure, segment } = props
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [selectedSurvey, setSelectedSurvey] = useState('');
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [selectedMeasure, setSelectedMeasure] = useState('');
  const [selectedSegment, setSelectedSegment] = useState('');
  const toggle = () => setIsOpen(!isOpen);
  useEffect(() => {
    getPeriodOptions().then((periods) => {
      setSelectedPeriod(periods.find((item) => item.id === period).label);
    })
    getSurveysOptions('Bankwide').then((surveys) => {
      setSelectedSurvey(surveys.find((item) => item.id === survey).label)
    })
    getQuestionOptions(survey.toString()).then((questions) => {
      setSelectedQuestion(questions.find((item) => item.id === question).label)
    })
    getMeasureOptions(survey.toString(), question.toString()).then((measuresOptions) => {
      setSelectedMeasure(measuresOptions.find((item) => item.id === measure).label)
    })
    getSegmentOptions(survey.toString(), question.toString()).then((segments) => {
      setSelectedSegment(segments.find((item) => item.id === segment).label)
    })
  }, [])
  return (
    <div>
      <div>
        <FontAwesomeIcon icon="plus" verticalAlign="initial" size="md" onClick={toggle} />
        &nbsp;
        {name}
      </div>
      <Container fluid>
        <Row>
          {addRankingColumn &&
            <Col className="col">
              <span>Ranking</span>
            </Col>
          }
          <Col className="col">
            <Collapse isOpen={isOpen}>
              <ul style={{ fontWeight: 'normal', padding: '10px 0px', margin: 'auto' }}>
                <li style={{ margin: 'auto', maxWidth: '100%', whiteSpace: 'pre-wrap' }}>{selectedPeriod}</li>
                <li style={{ margin: 'auto', maxWidth: '100%', whiteSpace: 'pre-wrap' }}>{selectedSurvey}</li>
                <li style={{ margin: 'auto', maxWidth: '100%', whiteSpace: 'pre-wrap' }}>{selectedQuestion}</li>
                <li style={{ margin: 'auto', maxWidth: '100%', whiteSpace: 'pre-wrap' }}>{selectedMeasure}</li>
                <li style={{ margin: 'auto', maxWidth: '100%', whiteSpace: 'pre-wrap' }}>{selectedSegment}</li>
              </ul>
            </Collapse>
            <span>Measure</span>
          </Col>
          {addNumberOfSurveys &&
            <Col className="col">
              <span># Responses</span>
            </Col>
          }
        </Row>
      </Container>
    </div>
  );
};
